import { GridCellParams, GridSingleSelectColDef } from '@mui/x-data-grid-pro';
import { v4 } from 'uuid';
import { standardOperators } from '../../../Compounds/UpstackDataGrid/helpers';
import { Icon } from '../../../Atoms/Icon';
import { ComponentName, getMetaData } from '../../../Compounds/DetailsDrawer/detailsDrawersHelpers';
import { DetailCTARenderer } from '../../../Compounds/UpstackDataGrid/CellRenderers';

export const DefaultApMapGridColumnDefs: GridSingleSelectColDef[] = [
  {
    field: 'details',
    headerName: '',
    sortable: false,
    width: 65,
    filterable: false,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    renderCell: (params: GridCellParams) => (
      <DetailCTARenderer
        data={params}
        value={''}
        valueFormatted={''}
        state={{
          id: v4(),
          data: params.row,
          ...getMetaData({ name: ComponentName.AP_MAP, id: params.row.id })
        }}
      />
    ),
    hideable: false,
    disableReorder: true
  },
  {
    headerName: 'Salesforce AP',
    field: 'ap_name',
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    sortable: true,
    filterable: true,
    filterOperators: standardOperators(),
    renderCell: (params: GridCellParams) => (
      <a
        className="text-indigo"
        title="Open in Salesforce"
        href={`${process.env.REACT_APP_SALESFORCE_INSTANCE_URL}/lightning/r/Account/${params.row.ap_sfid}/view`}
        target="_blank"
        rel="noopener noreferrer">
        <div className="flex items-center text-small">
          {params.row.ap_name}
          <Icon type="external" />
        </div>
      </a>
    )
  },
  {
    field: 'ap_rpm',
    headerName: 'RPM Agency Group',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators(),
    description: 'Drag to move column'
  },
  {
    field: 'ap_rpm_rep_name',
    headerName: 'RPM Rep Assignment',
    sortable: true,
    filterable: true,
    flex: 1,
    type: 'singleSelect',
    valueOptions: [],
    getOptionLabel: (value) => String(value),
    getOptionValue: (value) => value,
    filterOperators: standardOperators(),
    description: 'Drag to move column',
    renderCell: (params: GridCellParams) => (
      <div className="flex items-center text-small">
        {params.row.ap_rpm_rep_id ? `${params.row.ap_rpm_rep_name}, ${params.row.ap_rpm_rep_agency_name}` : ''}
      </div>
    )
  }
];
